globalThis.Player = class Player {
  constructor(config) {
    this.config = config;
    this.index = config.index;
    this.sprinting = false;
    this.left_walled = false;
    this.right_walled = false;
    this.grounded = false;
    this.floating = false;
    this.moving = false;
    this.direction = 1;
    this.position = new Vector2();
    this.div = document.createElement("div");
    this.div.classList.add("player", "color" + this.index);
    this.label = document.createElement("label");
    this.div.append(this.label);
    if (config.remote) this.div.classList.add("remote");
    else this.controller = new PlayerController(this);
    this.animator = new PlayerAnimator(this);
  }

  remove() {
    this.div.remove();
    this.controller?.remove();
    this.animator.remove();
  }

  update(update) {
    PlayerUpdate.prototype.apply.call(update, this);
    this.render();
  }

  jump() {
    globalThis.CLIENT.jump(this.index);
  }

  move(direction, sprinting) {
    globalThis.CLIENT.move(this.index, direction, sprinting);
  }

  moveVertically(direction) {
    globalThis.CLIENT.moveVertically(this.index, direction);
  }

  render() {
    const num = "⁰¹²³⁴⁵⁶⁷⁸⁹"[this.index];
    this.label.innerText = `${this.name || "Player"}${num}`;
    this.div.style.setProperty("--x", this.position.x);
    this.div.style.setProperty("--y", this.position.y);
    this.div.style.setProperty("--direction", this.direction);
  }

  setSpritePosition(x, y) {
    this.div.style.setProperty("--sprite-x", x);
    this.div.style.setProperty("--sprite-y", y);
  }

  setDebugLeft(enabled) {
    if (enabled) this.div.classList.add("left");
    else this.div.classList.remove("left");
  }

  setDebugRight(enabled) {
    if (enabled) this.div.classList.add("right");
    else this.div.classList.remove("right");
  }

  setDebugBottom(enabled) {
    if (enabled) this.div.classList.add("bottom");
    else this.div.classList.remove("bottom");
  }

  setDebugTop(enabled) {
    if (enabled) this.div.classList.add("top");
    else this.div.classList.remove("top");
  }

  isCenterInScope(border = 0) {
    const rect = this.div.getBoundingClientRect();
    const clientX = (rect.left + rect.right) / 2;
    const clientY = (rect.top + rect.bottom) / 2;
    return (
      clientX > innerWidth * border &&
      clientX < innerWidth * (1 - border) &&
      clientY > innerHeight * border &&
      clientY < innerHeight * (1 - border)
    );
  }
};
